import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { Button ,Modal,Toast} from 'zarm';
import {
  IconFont
} from '@wap/components';
import request from '@utils/request';
import './index.less'
// OK镜处方
function OkTreatemnt(props) {
  // showQuote: 是否显示引用按钮
  const { tenantId, patientId, showQuote } = props;
  const [open, setOpen] = useState(true); // 是否展开，默认展开，可以收起
  const [quoteData, setQuoteData] = useState(null); // 是否有引用的数据
  const [okTreatment, setOkTreatment] = useState({});
  const [showTreatment, setShowTreatment] = useState(true);
  // const { okTreatment = {} } = props;
  /**
   * 获取ok镜处方的病例记录
   */
  const fetchOkTreatHistory = () => {
    const params = {
      patiId: patientId,
      tenaId: tenantId,
      examCode: 85005
    };
    // request.get('form_designer/ok_treatment/ok_app/emr_historical/detail', params).then(async res => {
      request.get('form_designer/ok_treatment/ok_app/prescription/latest_detail', params).then(async res => {
      const { recoreText, ...rest } = res|| {};
      setOkTreatment(rest);
      setQuoteData(recoreText);
      if(!recoreText){
        setShowTreatment(false)
      }else if(recoreText==='{}'){
        setShowTreatment(false)
      }else {
        setShowTreatment(true)
      }
      // const okTreatment = res?.data || {};
      // setOkTreatment(okTreatment);
    });
  };
  /**
   * 引用数据
   * @param {*}
   */
  const quoteTreament = () => {
    const modal = Modal.confirm({
      content: '是否引用数据',
      onCancel: () => {
        return new Promise((resolve, reject) => {
          resolve();
        }).catch(() => {
          return false; // 返回false，可使弹窗无法关闭
        });
      },
      onOk: () => {
        return new Promise((resolve, reject) => {
          const examData = {list: [JSON.parse(quoteData) || {}]}
          props.quoteTreament(examData);
          Toast.show({
            content: '引用成功',
            stayTime: 1000,
            afterClose: () => {
            },
          });
          resolve();
        }).catch((err) => {
          console.log(err)
          return false; // 返回false，可使弹窗无法关闭
        });

      },
    });
  //   const data =  {
  //      examCode
  //      examContent: {
  //         "dataOdBrandId": "774920435614744987",
  //         "dataOdBrandCode": "10234",
  //         "dataOdBrandName": "第七宗罪",
  //         "dataOdOne": "8",
  //         "dataOdTwo": "6",
  //         "dataOdThree": "7",
  //         "dataOsBrandId": "776266884533322523",
  //         "dataOsBrandCode": "10249",
  //         "dataOsBrandName": "猛龙摆尾",
  //         "dataOsOne": "96",
  //         "dataOsTwo": "8",
  //         "dataOsThree": "45",
  //         "dataOsFour": "89"
  //     },
  //     "examStatus": 0,
  //     "examFiles": []
  // }


  }
  /**
   * 展开收起
   */
  const slideToggle = () => {
    setOpen(!open)
  }
  useEffect(() => {
    fetchOkTreatHistory();
  }, []);

  const hasOkTreatment =!!okTreatment.recordId;
  if (hasOkTreatment) {
    return (
      <div className={`okTreatemnt-wrapper ${open ? 'open' : 'close'}`}>
        <div className="title">
          <span>OK镜处方</span>
          <span>时间：{okTreatment.examDate ? moment(+okTreatment.examDate * 1000).format('YYYY-MM-DD') : '-'}</span>
          <span>医生：{okTreatment.doctorName}</span>
        </div>
        <div className="content">
          <div className='examContent'>
            <p>
              <span className="eyesTypeOD">OD</span>
              {okTreatment.examOdContent || '-'}
            </p>
            <p>
              <span className="eyesTypeOS">OS</span> {okTreatment.examOsContent || '-'}
            </p>
          </div>
         {showQuote && showTreatment && <Button theme="primary" size="xs" onClick={() => quoteTreament(quoteData)}>引用</Button>}
        </div>
        <div className="packupIcon">
          <IconFont
            className="iconshouqi"
            type="icon-shouqi2"
            onClick={slideToggle}
          />
        </div>

      </div>
    );
  }
  return '';
}
export default OkTreatemnt;
